export const REQUEST_ADVISOR_INFO = 'requestAdvisorInfo';
export const REQUEST_ADVISOR_PHOTO = 'requestAdvisorPhoto';
export const SET_ADVISOR_INFO = 'setAdvisorInfo';
export const REQUEST_ADVISOR_LOGIN_REDIRECT = 'requestAdvisorLoginRedirect';
export const SET_ADVISOR_ERROR = 'setAdvisorError';
export const REQUEST_ADVISER_FEATURES = 'requestAdviserFeatures';
